"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _step = _interopRequireDefault(require("../styles/step"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject());

var Step =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Step, _Component);

  function Step() {
    (0, _classCallCheck2["default"])(this, Step);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Step).apply(this, arguments));
  }

  (0, _createClass2["default"])(Step, [{
    key: "render",
    value: function render() {
      var styles = this.compileStyled(_step["default"]),
          _this$props = this.props,
          number = _this$props.number,
          hint = _this$props.hint,
          children = _this$props.children,
          NumberIcon = styles.number.icon;
      return _react["default"].createElement(Div, {
        styles: styles.root
      }, _react["default"].createElement(Div, {
        styles: styles.number
      }, NumberIcon ? _react["default"].createElement(NumberIcon, {
        fill: styles.number.color,
        width: styles.number.width,
        height: styles.number.height
      }) : number), _react["default"].createElement(Div, {
        styles: styles.labelWrapper
      }, children ? _react["default"].createElement(Div, {
        styles: styles.name
      }, children) : null, hint ? _react["default"].createElement(Div, {
        styles: styles.hint
      }, hint) : null));
    }
  }]);
  return Step;
}(_Component2["default"]);

(0, _defineProperty2["default"])(Step, "displayName", 'StepperStep');
(0, _defineProperty2["default"])(Step, "propTypes", {
  passed: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  number: _propTypes["default"].number,
  children: _propTypes["default"].any,
  hint: _propTypes["default"].any
});
var _default = Step;
exports["default"] = _default;